import { render, staticRenderFns } from "./verErros.vue?vue&type=template&id=a2ba1c20&scoped=true"
import script from "./verErros.vue?vue&type=script&lang=js"
export * from "./verErros.vue?vue&type=script&lang=js"
import style0 from "./verErros.vue?vue&type=style&index=0&id=a2ba1c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ba1c20",
  null
  
)

export default component.exports